import React, { Component } from "react";
import { connect } from "react-redux";
import { FiPlus, FiSearch, FiDownload, FiMoreHorizontal } from "react-icons/fi";
import { FormGroup, FormControl, Dropdown } from "react-bootstrap";
import Loading from "components/Loading";
import Layout from "components/Layout";
import ShiftList from "components/Shifts";
import ShiftEditModal from "components/Shifts/ShiftEditModal";
import PillToggleGroup from "components/PillToggleGroup";
import {
	shiftType,
	shiftTypeFilterAll,
	matchesShiftTypeFilter,
} from "services/shiftsService";
import { showModal, hideModal } from "actions/modalActions";
import * as shiftsActions from "actions/shiftsActions";
import * as calendarsActions from "actions/calendarsActions";
import * as timesActions from "actions/timesActions";
import * as groupsActions from "actions/groupsActions";
import Modal from "components/Modal";
import HelpBanner from "components/HelpBanner";
import { helpUrls } from "utils/helpUrls";
import { withTranslation } from "react-i18next";

class Shifts extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchShift: "",
			filterTypeId: shiftTypeFilterAll,
			filterStatus: "activos", // Default: activos
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewShiftModal = this.openNewShiftModal.bind(this);
		this.getShifts = this.getShifts.bind(this);
	}

	componentDidMount() {
		this.getShifts();
		this.props.getShiftTypes();
		this.props.getSelectableTimeTypes();
		this.props.getDefaultTimeType();
		this.props.getSelectableDayTypes();
		this.props.getAllGroups();
	}

	handleChangeSearch = (event) => {
		this.setState(
			{
				[event.target.id]: event.target.value,
			},
			() => {
				this.getShifts();
			}
		);
	};

	handleTypeFilterChange = (filterTypeId) => {
		this.setState({ filterTypeId });
	};

	getFilteredShifts = () => {
		const { shifts } = this.props;
		const { filterTypeId } = this.state;
		if (!shifts) return [];
		return shifts.filter((shift) =>
			matchesShiftTypeFilter(shift, filterTypeId)
		);
	};

	async getShifts() {
		const params = {
			q: this.state.searchShift,
		};
		// Agregar parámetros según el filtro de estado
		switch (this.state.filterStatus) {
			case "activos":
				params.active = true;
				break;
			case "inactivos":
				params.active = false;
				break;
			case "todos":
			default:
				params.active = null;
				break;
		}
		await this.props.getAllShifts(params);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewShiftModal() {
		const { filterTypeId } = this.state;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("shifts.newShift"),
				style: { width: "600px" },
				content: (
					<ShiftEditModal
						getShifts={this.getShifts}
						handleClose={this.closeModal}
						initialType={filterTypeId || undefined}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	getContent = () => {
		if (this.props.loading_shifts) {
			return <Loading />;
		}

		if (this.props.error_shifts) {
			return this.props.t("shifts.errorLoading") + ": " + this.props.error_shifts;
		}

		if (!this.props.shifts) {
			return this.props.t("shifts.errorLoading");
		}

		return (
			<ShiftList
				shifts={this.getFilteredShifts()}
				getShifts={this.getShifts}
			/>
		);
	};

	renderFilters = () => {
		const { filterStatus } = this.state;

		return (
			<div className="heading-filters">
				<FormGroup className="form-group form-search" controlId="searchShift">
					<FormControl
						type="text"
						placeholder={this.props.t("common.searchPlaceholder")}
						value={this.state.searchShift}
						onChange={this.handleChangeSearch}
					/>
					<FiSearch />
				</FormGroup>
				<FormGroup className="form-group form-search" controlId="filterStatus">
					<FormControl
						as="select"
						value={filterStatus}
						onChange={this.handleChangeSearch}
					>
						<option value="todos">{this.props.t("shifts.filterAll")}</option>
						<option value="activos">{this.props.t("shifts.filterActive")}</option>
						<option value="inactivos">{this.props.t("shifts.filterInactive")}</option>
					</FormControl>
				</FormGroup>
			</div>
		);
	};

	renderTypeFilter = () => {
		const { filterTypeId } = this.state;

		return (
			<div className="shifts-type-filter">
				<PillToggleGroup
					className="shifts-type-filter__pills"
					ariaLabel={this.props.t("shifts.filterByType")}
					variant="segmented"
					options={[
						{
							value: shiftTypeFilterAll,
							label: this.props.t("shifts.filterAll"),
						},
						{
							value: shiftType.work,
							label: this.props.t("shifts.form.typeWork"),
						},
						{
							value: shiftType.automatic,
							label: this.props.t("shifts.form.typeAutomatic"),
						},
						{
							value: shiftType.absence,
							label: this.props.t("shifts.form.typeAbsence"),
						},
						{
							value: shiftType.vacation,
							label: this.props.t("shifts.form.typeVacation"),
						},
					]}
					value={filterTypeId}
					onChange={this.handleTypeFilterChange}
				/>
			</div>
		);
	};

	render() {
		return (
			<>
				<Layout configSidebar={true} className="page-shifts" context="shifts">
					<div className="heading">
						<h1 className="title">{this.props.t("shifts.title")}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t("common.needHelp")}
								text={this.props.t("common.helpText")}
								linkText={this.props.t("common.moreInfo")}
								linkHref={helpUrls.shift}
							/>
						</div>

						{this.renderFilters()}

						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t("shifts.createShift")}
								onClick={this.openNewShiftModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>

							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.props.history.push("/shifts/import")}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t("shifts.importShifts")}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<div className="shifts-page-content">
						{this.renderTypeFilter()}
						{this.getContent()}
					</div>
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.timesReducer,
		...reducers.shiftsReducer,
		...reducers.groupsReducer,
		loading: reducers.shiftsReducer.loading,
		loading_shifts: reducers.shiftsReducer.loading_shifts,
		error_shifts: reducers.shiftsReducer.error_shifts,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
	getShiftTypes: () => dispatch(shiftsActions.getShiftTypes()),
	getAllGroups: () => dispatch(groupsActions.getAllGroups()),
	getSelectableTimeTypes: () => dispatch(timesActions.getSelectableTimeTypes()),
	getDefaultTimeType: () => dispatch(timesActions.getDefaultTimeType()),
	getSelectableDayTypes: () =>
		dispatch(calendarsActions.getSelectableDayTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Shifts));
